import { useEffect } from 'react';
import { BootResponse } from '../constants/apiResponses.types';
import useApi from './useApi';
import { resolveThemeFontHrefs } from '../utils/googleFonts';

export default function useThemeFont() {
  const API = useApi({});
  const publisherMetaData = API.getPublisherMeta.data as BootResponse;

  const storeTheme = publisherMetaData?.storeTheme;
  const fontHrefs = resolveThemeFontHrefs([
    storeTheme?.general?.font,
    storeTheme?.login?.font,
    storeTheme?.login?.logoutScreen?.font,
  ]);
  const fontHrefsKey = fontHrefs.join('|');

  useEffect(() => {
    fontHrefs.forEach((href) => {
      if (document.querySelector(`link[rel="stylesheet"][href="${href}"]`)) {
        return;
      }
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
    });
  }, [fontHrefsKey]);
}
